import { useState } from "react";
import { useDebounce } from "src/hooks/useDebounce";
import { useLocalFilter } from "src/hooks/useLocalFilter";

interface UseLocalSearchOptions {
	debounceMs?: number;
}

export function useLocalSearch<T>(
	values: T[],
	keys: (keyof T)[],
	{ debounceMs = 300 }: UseLocalSearchOptions = {},
) {
	const [searchValue, setSearchValue] = useState("");
	const debouncedSearch = useDebounce(searchValue, debounceMs);
	const filteredValues = useLocalFilter(values, keys, debouncedSearch);
	const trimmedSearch = debouncedSearch.trim();

	return {
		searchValue,
		setSearchValue,
		filteredValues,
		trimmedSearch,
		clearSearch: () => setSearchValue(""),
	};
}
